import { forwardRef, Fragment } from "@wordpress/element";
import { Transition } from '@headlessui/react'

const CSS_CLASSES = "fixed inset-0 transition-opacity bg-opacity-75 bg-ui-900/50";

export function Backdrop(props: { blur?: boolean, children?: Function }) {
  if (props.blur) {
    return (
    <Transition.Child
      as={Fragment}
      enter="ease-out duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="ease-in duration-200"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
        {props.children
          ? props.children({ className: "fixed inset-0 bg-ui-900/30 backdrop-blur-sm" })
          : <div className="fixed inset-0 bg-ui-900/30 backdrop-blur-sm"></div>
        }
        </Transition.Child>
    )
  } else {
    return (
      <>
        {props.children
          ? props.children({ className: CSS_CLASSES })
          : <Backdrop.Layer></Backdrop.Layer>
        }
      </>
    )
  }
}

Backdrop.Layer = forwardRef((props: any, ref) => (
  <div ref={ref} className={`${CSS_CLASSES}`}></div>
));
